$(document).ready(function () {
	$('.scroller-mobile').slick({
		slide: '.scroller-mobile__item',
		rows: 0,
		pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false,
		adaptiveHeight: true,
		fade: false,
		infinite: true,
		draggable: true,
		arrows: false,
		dots: true,
		appendDots: '.scroller-mobile__dots',
		centerMode: false,
		slidesToShow: 1,
	});

	$('.text-block-faqs .faq-item').on('click', function () {
		$(this).children('.base-text').slideToggle();
		$(this).children('.plus-minus-toggle').toggleClass('collapsed');
	});

	$('.scroller-item-text:not(:first)').hide();
	$('.show-hide-button:not(:first)').addClass('collapsed');

	$('.scroller-item-header').click(function () {
		$(this).closest('.scroller-item').find('.scroller-item-text').animate({
			opacity: 'toggle',
			height: 'toggle'
		  }, 300);
		if ($(this).closest('.scroller-item').find('.show-hide-button').hasClass('collapsed')) {
			$(this).closest('.scroller-item').find('.show-hide-button').removeClass('collapsed');
		} else {
			$(this).closest('.scroller-item').find('.show-hide-button').addClass('collapsed');
		}

		$(this).closest('.scroller-item').siblings().find('.scroller-item-text').hide('slow');
		$(this).closest('.scroller-item').siblings().find('.show-hide-button').addClass('collapsed');
	});
});
